import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/lib/contact";

export default function WhatsAppFab({ message }) {
  return (
    <a
      data-testid="whatsapp-fab"
      href={buildWhatsAppLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contacter DNCM Vision sur WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full dncm-wa-ring" aria-hidden="true" />
      <span
        className="relative flex items-center gap-2 pl-4 pr-5 py-3 rounded-full font-mono-d text-[12px] tracking-[0.22em] uppercase text-[#001018] dncm-btn-glow"
        style={{
          background: "linear-gradient(180deg, #6ff3ff 0%, #00cfff 60%, #00a6cf 100%)",
        }}
      >
        <MessageCircle className="w-4 h-4" />
        <span className="hidden sm:inline">WhatsApp</span>
      </span>
    </a>
  );
}
